// Consumption dashboard ("Suivi conso") — the annual gauge compares the invoices counted
// since January 1st with the subscribed annual volume. On the year the customer subscribes,
// that volume is reduced to the share of the year left from the subscription day.
//
// The subscription day is the earliest iz_package.date_from, finished packages included:
// switching package closes the old row and opens a new one dated that day, which must not
// restart a prorata for a long-standing customer.

function toIsoDate(value){
    if(!value){ return null ; }
    if(value instanceof Date){
        const pad = n => String(n).padStart(2, "0") ;
        return value.getFullYear()+"-"+pad(value.getMonth()+1)+"-"+pad(value.getDate()) ;
    }
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value)) ;
    return match ? match[0] : null ;
}

/** Earliest date_from of the given packages, as YYYY-MM-DD, or null when none is dated. */
function subscriptionStartDate(packages){
    const dates = (packages || []).map(p => toIsoDate(p && p.date_from)).filter(Boolean).sort() ;
    return dates.length > 0 ? dates[0] : null ;
}

/**
 * Annual volume to show on the gauge for the year of `today`. When the subscription started
 * during that year (after January 1st), returns the volume × days left including the start
 * day ÷ days of the year, rounded.
 */
function proratedAnnualTotal(annualTotal, startDate, today){
    const start = toIsoDate(startDate) ;
    const total = Number(annualTotal) ;
    if(!start || !(total > 0)){ return { total: annualTotal, prorata: false } ; }
    const [year, month, day] = start.split("-").map(Number) ;
    const currentYear = (today || new Date()).getFullYear() ;
    if(year !== currentYear || (month === 1 && day === 1)){ return { total: annualTotal, prorata: false } ; }

    const DAY = 24 * 3600 * 1000 ;
    const daysInYear = (Date.UTC(year + 1, 0, 1) - Date.UTC(year, 0, 1)) / DAY ;
    const daysLeft = (Date.UTC(year + 1, 0, 1) - Date.UTC(year, month - 1, day)) / DAY ;
    return { total: Math.round(total * daysLeft / daysInYear), prorata: true } ;
}

module.exports = { subscriptionStartDate, proratedAnnualTotal } ;
